export default __webpack_public_path__ + "static/media/1.16e8d4e9.svg";